export default "__VITE_ASSET__91fe8d02__"